import { MsClose as l, MsError as o, MsInformationCircle as s, MsWarningCircle as r, MsCheckCircle as a } from "@sunrise/icons";
import { Components as t } from "@sunrise/types";
import { defineComponent as m, computed as n } from "vue";
const f = m({
  name: "CsToast",
  components: {
    MsCheckCircle: a,
    MsWarningCircle: r,
    MsInformationCircle: s,
    MsError: o,
    MsClose: l
  },
  props: {
    type: String,
    title: String
  },
  emits: ["close"],
  setup(e, { emit: c }) {
    const T = n(() => {
      switch (e.type) {
        case t.CsToast.ToastType.WARNING:
          return "bg-color-alert-pending-100";
        case t.CsToast.ToastType.INFORMATION:
          return "bg-color-alert-information-100";
        case t.CsToast.ToastType.ERROR:
          return "bg-color-alert-negative-100";
        case t.CsToast.ToastType.POSITIVE:
        default:
          return "bg-color-alert-positive-100";
      }
    }), p = n(() => {
      switch (e.type) {
        case t.CsToast.ToastType.WARNING:
          return r;
        case t.CsToast.ToastType.INFORMATION:
          return s;
        case t.CsToast.ToastType.ERROR:
          return o;
        case t.CsToast.ToastType.POSITIVE:
        default:
          return a;
      }
    });
    function i() {
      c("close");
    }
    return {
      computedIcon: p,
      computedBgColor: T,
      close: i
    };
  }
});
export {
  f as default
};
